import { render, staticRenderFns } from "./ChartAnnotations.vue?vue&type=template&id=71e11cd5&scoped=true"
import script from "./ChartAnnotations.vue?vue&type=script&lang=js"
export * from "./ChartAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ChartAnnotations.vue?vue&type=style&index=0&id=71e11cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e11cd5",
  null
  
)

export default component.exports